export default "__VITE_ASSET__BVMARP_Q__"